import type { ReactNode } from 'react'
import styles from './intent.module.css'

interface DisclosureProps {
  label: string
  /** Open on mount when the field already holds something. */
  defaultOpen: boolean
  /** Shown as a badge so collapsed content is never invisible. */
  filled?: string
  children: ReactNode
}

/**
 * Optional context fields stay collapsed until needed. Collapsing only hides the
 * control — it never removes the content or excludes it from a prompt.
 */
export function Disclosure({ label, defaultOpen, filled, children }: DisclosureProps) {
  return (
    <details className={styles.disclosure} open={defaultOpen}>
      <summary>
        {label}
        {filled ? <span className={styles.filled}>{filled}</span> : null}
      </summary>
      <div className={styles.disclosureBody}>{children}</div>
    </details>
  )
}
